// src/components/scan/ScanSummary.tsx
import React from 'react';

interface ScanSummaryProps {
  result: {
    securityScore?: number;
    status?: string;
  } | null;
  t: (key: string) => string;
}

const getScoreColor = (score: number) => {
  if (score >= 80) return 'text-green-500';
  if (score >= 50) return 'text-yellow-500';
  return 'text-red-500';
};

const getStatusColor = (status: string) => {
  switch (status) {
    case 'completed':
      return 'bg-green-500';
    case 'failed':
      return 'bg-red-500';
    default:
      return 'bg-gray-500';
  }
};

const ScanSummary: React.FC<ScanSummaryProps> = ({ result, t }) => {
  const securityScore = result?.securityScore ?? 100;
  const status = result?.status ?? 'loading';

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-8">
      {/* Título principal */}
      <div className="col-span-2 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white">
          {t('scan.results')}
        </h2>
      </div>

      {/* Score Card */}
      <div className="text-center">
        <h3 className="text-lg md:text-xl mb-2 text-white">
          {t('scan.securityScore')}
        </h3>
        <div className="relative inline-block">
          <span
            className={`font-bold transition-colors duration-300
              text-5xl md:text-6xl
              ${getScoreColor(securityScore)}`}
          >
            {securityScore}
          </span>
        </div>
      </div>

      {/* Status Card */}
      <div className="text-center">
        <h3 className="text-lg md:text-xl mb-2 text-white">
          {t('scan.status')}
        </h3>
        <span
          className={`inline-block rounded-full font-semibold text-gray-100
            ${getStatusColor(status)}
            px-4 py-2 text-base md:px-6 md:py-3 md:text-lg`}
        >
          {status === 'completed'
            ? t('scan.completed')
            : status === 'failed'
            ? t('scan.failed')
            : t('scan.loadingStatus')}
        </span>
      </div>
    </div>
  );
};

export default ScanSummary;
